import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "bedrooms-select-dropdown" }

import { computed, ref, PropType } from "vue";
import singleSelect from "./single-select.vue";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import { FieldSize } from "@/enums/system/FieldSize";


export default /*#__PURE__*/_defineComponent({
  __name: 'bedrooms-select',
  props: {
  /**
   * The number value used with `v-model` to the component.
   * @type {number}
   * @required
   */
  modelValue: {
    type: Number,
    required: true,
  },
  /**
   * The width of the field, defined by the `FieldSize` enum.
   * @type {FieldSize}
   * @default FieldSize.Full
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
  /**
   * Determines whether the specific control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * A custom validation function for validating the input field.
   * @type {Function}
   * @optional
   */
  customValidation: {
    type: Function,
    required: false,
  },

  /**
   * A custom error message to display when validation fails.
   * @type {string}
   * @default ''
   */
  customErrorMessage: {
    type: String,
    default: "",
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes.
   * This is used to update the v-model variable in the parent component and control the visibility of the modal.
   * @event update:modelValue
   * @property {boolean} value - The updated state to reflect whether the modal should be shown or hidden.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const value = computed({
  get: () => props.modelValue,
  set: (value: Number) => emit("update:modelValue", value),
});

const numberArray = ref<IDDescriptionPair[]>([]);

/* Run this immediately to populate the number array.
 * Without this, the v-model on the single-select doesn't work correctly */
for (let i = 0; i <= 15; i++) {
  const description = i === 0 ? "Studio/0" : i.toString();
  numberArray.value.push({ id: i, description: description });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(singleSelect, {
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        dataSource: numberArray.value,
        width: props.width,
        readOnly: props.readOnly,
        customValidation: props.customValidation,
        invalidMessage: props.customErrorMessage,
        "allow-zero-value": true,
        showSearch: false
      }, null, 8, ["modelValue", "dataSource", "width", "readOnly", "customValidation", "invalidMessage"])
    ])
  ], 64))
}
}

})